import { useState } from 'react';
import parse from 'html-react-parser';
import { responseValidateQuestion } from '../../../../interfaces';

type ResultOptionTriviaProps = {
    question: responseValidateQuestion
}

export const ResultOptionTrivia = ({ question }: ResultOptionTriviaProps) => {
  const [isShowJustify, setIsShowJustify] = useState( false );

  const handleShowJustify = () =>{
    setIsShowJustify(!isShowJustify);
  }

  return (
    <div className="acc">
        <button
            type="button"
            className={`acc__header ${isShowJustify ? 'selected' : ''}`}
            onClick={handleShowJustify}
        >
            <span className="acc__header-qa">
                <span className="acc__header-q">{ parse(question.question?.pregunta || "Pregunta") }</span>
                <span className="acc__header-a"><b>Opción dada:</b> { parse(question.optionSelect?.texto || "Opción") }</span>
            </span>
            <span className={`acc__header-sym ${question.ok ? 'correct' : 'incorrect'}`}></span>
        </button>
        <div
            id="acc-1"
            className="acc__content"
            aria-labelledby="acc-header"
        >
            <p><b>Correcta: </b> { parse(question.optionCorrect?.texto || "Opción correcta") }</p>
            <b>Justificación:</b>
            {parse(question.question?.justificacion || '')}
        </div>
    </div>
  )
}